import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter } from "../../../utils";

function ReclaimedSchemeView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Scheme Name",
      children: prodd?.schName ?? "N/A",
    },
    {
      key: "5",
      label: "Status",
      children: prodd?.schStatus ?? "N/A",
    },
    {
      key: "2",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "3",
      label: "Subcounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "4",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "55",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    },
    {
      key: "6",
      label: "Latitudes",
      children: prodd?.schLat ?? "N/A",
    },
    {
      key: "7",
      label: "Longitudes",
      children: prodd?.schLong ?? "N/A",
    },
    
    {
      key: "9",
      label: "Size (Acres)",
      children: prodd?.schSize ?? "N/A",
    },
    {
      key: "10",
      label: "Category",
      children: prodd?.schCategory ?? "N/A",
    },
    
  ];

  const items2 = [
    {
      key: "1",
      label: "Contractor Name",
      children: prodd?.schContName ?? "N/A",
    },
    {
      key: "5",
      label: "Contract Start Date",
      children: (
        <div>
          {prodd?.schStartDate
            ? moment(prodd?.schStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "2",
      label: "Contract End Date",
      children: (
        <div>
          {prodd?.schEndDate
            ? moment(prodd?.schEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "3",
      label: "Revised End Date",
      children: (
        <div>
          {prodd?.schRevisedDate
            ? moment(prodd?.schRevisedDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "4",
      label: "Mode of Funding",
      children: prodd?.fmType ?? "N/A",
    },
    {
      key: "6",
      label: "Actual Expinditure to Date",
      children: <div>{cashConverter(prodd?.schExpenditureToDate)}</div>,
    },
    {
      key: "6",
      label: "Disbursed Amount",
      children: <div>{cashConverter(prodd?.schDisbursedAmount)}</div>,
    },
  ];

  const items3 = [
    {
      key: "1",
      label: "Scope of Work",
      children: prodd?.schWorkScope ?? "N/A",
    },

    {
      key: "4",
      label: "Land Use",
      children: prodd?.schLandUse ?? "N/A",
    },
    {
      key: "2",
      label: "Productivity Per kg/acre",
      children: prodd?.schProductivityArea ?? "N/A",
    },
    {
      key: "3",
      label: "Technology Used",
      children: prodd?.lrtType ?? "N/A",
    },
    {
      key: "6",
      label: "Benefitiary Households",
      children: prodd?.schHousehold ?? "N/A",
    },  
    {
      key: "9",
      label: "Pathways",
      children: prodd?.schPathways ?? "N/A",
    },
    {
      key: "10",
      label: "Cost",
      children:<div>{cashConverter(prodd?.schCost)}</div>,
    },
    {
      key: "11",
      label: "Topography",
      children: prodd?.schTypography ?? "N/A",
    },
    {
      key: "12",
      label: "Soil Type",
      children: prodd?.schSoilType?? "N/A",
    },
    
    
  ];

  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Reclaimed Scheme Details</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Scheme Details"
          column={2}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title="Contractor Details"
          column={2}
          colon={false}
          items={items2}
          layout="vertical"
        />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Other Information"
          column={2}
          colon={false}
          items={items3}
          layout="vertical"
        />
      </div>
    </Drawer>
  );
}

export default ReclaimedSchemeView;
